import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AllMaterialModule } from "../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";
import { UIRouterModule } from "@uirouter/angular";
import SharedModule from "../shared/shared.module";
import { CoreModule } from "../core/core.module";
import { CompetenceSearchComponent } from "./competence-search.component";
import { SumActivitiesComponent } from "./activity-summation.component";
import { complianceState, competenceSearchState, sumActivitiesState } from "./compliance.states";
import { ComponentsModule } from "../components/components.installer";
import { MatDatepickerModule } from "@angular/material";

let STATES = [complianceState, competenceSearchState, sumActivitiesState];

@NgModule({
    imports: [
        AllMaterialModule,
        FormsModule,
        CommonModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: STATES }),
        ComponentsModule,
        MatDatepickerModule
    ],
    declarations: [CompetenceSearchComponent, SumActivitiesComponent]
})
export class ComplianceModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/compliance/compliance.module.ts